import { bindActionCreators, Dispatch } from "redux";
import { connect, RootStateOrAny } from "react-redux";

import { Typography } from "antd";

import { getInfoForCarePlanPage } from "store/eligibility/pac/actions";
import { getDocuments } from "store/eligibility/carePlan/actions";
import { getUnreadTypeCount } from "store/eligibility/pac/actions";
import { updateReadInfo } from "store/eligibility/pac/actions";

//eligibility info page related
import { SearchCriteria, search, getProvider } from "store/eligibility/actions";
import { getPlans, getNotes } from "store/eligibility/pac/actions";
import { downloadMemberDocument } from "store/eligibility/documents/actions";

import CarePlansCards from "components/CaseManagement/CarePlans";

import './index.scss';

const { Title } = Typography;

interface CarePlansPageProps {
  getInfoForCarePlanPage(userId: string, pacType: string): any,
  getDocuments(userId: string): any,
  getUnreadTypeCount(userId: string, pacType: string): any,
  isFetchingInfoForCarePlan: boolean,
  isFetchingCount: boolean,
  isFetching: boolean,

  //eligibility info page related
  search(searchCriteria: SearchCriteria): any,
  getProvider(providerKeyId: string, companyId: string): any,
  downloadMemberDocument(memberFilePath: string, memberFileName: string, membMpiNo: string): any,
  getPlans(id: string, companyId: string, userId: string): any,
  getNotes(userId: string, membMpiNo: string, companyId: string): any,
  updateReadInfo(passedUserId: string, passedPacUid: string, passedPacType: string): any,
}

const CarePlansPage = (props: CarePlansPageProps) => {

  return (
    <div className="case-management-page">
      <div className="header-title">
        <Title level={4} className="ml-3">Care Plans</Title>
      </div>
      <div className="search-section">
        <CarePlansCards
          getInfoForCarePlanPage={props.getInfoForCarePlanPage}
          getDocuments={props.getDocuments}
          getUnreadTypeCount={props.getUnreadTypeCount}
          updateReadInfo={props.updateReadInfo}
          isFetching={props.isFetching}
          isFetchingInfoForCarePlan={props.isFetchingInfoForCarePlan}
          isFetchingCount={props.isFetchingCount}

          //eligibility info page related
          search={props.search}
          getPlans={props.getPlans}
          getNotes={props.getNotes}
          getProvider={props.getProvider}
          downloadMemberDocument={props.downloadMemberDocument}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingInfoForCarePlan: store.rootReducer.eligibilityPAC.isFetchingInfoForCarePlan, //Care Plan and Care Note table
  isFetching: store.rootReducer.eligibilityCarePlan.isFetching, //Documents Table
  isFetchingCount: store.rootReducer.eligibilityPAC.isFetchingCount, //get unread count for all of them
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getInfoForCarePlanPage,
    getDocuments,
    getUnreadTypeCount,
    updateReadInfo,

    //eligibility info page related
    search,
    getProvider,
    getPlans,
    getNotes,
    downloadMemberDocument
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(CarePlansPage);
